import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { customization } from '@yola/ws-sdk';
import builtInGradients, { GRADIENT_ID_PREFIXES } from '../constants/built-in-gradients';

const usePredefinedGradients = () => {
  const dispatch = useDispatch();
  const customGradients = useSelector(customization.selectors.getCustomGradients);

  const predefinedGradients = useMemo(() => {
    const normalizedCustomGradients = customGradients.map(({ value }, index) => ({
      id: `${GRADIENT_ID_PREFIXES.CUSTOM}-${index}`,
      value,
    }));
    const combinedGradients = [...builtInGradients, ...normalizedCustomGradients];

    return combinedGradients.filter(
      (gradient, index, array) => index === array.findIndex((item) => item.value === gradient.value)
    );
  }, [customGradients]);

  const isGradientPredefined = useCallback(
    (gradientValue) => predefinedGradients.some(({ value }) => value === gradientValue),
    [predefinedGradients]
  );

  const saveCustomGradient = useCallback(
    (gradientValue) => {
      if (!gradientValue || isGradientPredefined(gradientValue)) {
        return;
      }

      dispatch(
        customization.actions.addCustomGradient({
          value: gradientValue,
        })
      );
    },
    [dispatch, isGradientPredefined]
  );

  return {
    predefinedGradients,
    saveCustomGradient,
  };
};

export default usePredefinedGradients;
